import { DataBean } from "../DataBean";


export class RequestNeed extends DataBean {

    public async createRequestNeed(idTypeNeed: number, description: string, idEmployee: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.RequestNeed_createRequestNeed_Number_String_Number", [idTypeNeed, description, idEmployee]);
    }

    public async updateStateRequestNeed(requestNeed: any, observation: string, state: number, idEmployee: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.RequestNeed_updateStateRequestNeed_com.orange.bean.RequestNeed_String_Number_Number", [requestNeed, observation, state, idEmployee]);
    }

    public async getRequestNeedCatalogRender(props: any, page: number, rows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getRequestNeedCatalogRender_java.util.Map_Number_Number", [props, page, rows]);
    }

    public async getRequestNeedHistoryCatalogRender(props: any, page: number, rows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getRequestNeedHistoryCatalogRender_java.util.Map_Number_Number", [props, page, rows]);
    }

}